import { PrivateRoute, RedirectToLogin } from "../../lib/auth";
import {
  LoadingComponent,
  withPageMetadata,
  metadata,
} from "@pga/pga-component-library";
import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { path } from "ramda";
import AuthRedirect from "./modal/AuthRedirect";
import RouteChangeHandler from "../../lib/Segment/RouteChangeHandler";

const AsyncJobDashboard = React.lazy(() => import("../job-search/Dashboard"));
const AsyncJobSearch = React.lazy(() => import("../job-search"));
const RecommendedJobsPage = React.lazy(
  () => import("../job-search/RecommendedJobsPage"),
);
const AsyncJobDetailPage = React.lazy(
  () => import("../job-posting/JobDetailPage"),
);
const AsyncApplicationSubmittedPage = React.lazy(
  () => import("../job-posting/ApplicationSubmittedPage"),
);
const AsyncLogout = React.lazy(() => import("../Logout"));
const AsyncEditJob = React.lazy(() => import("../EditJob"));
const AsyncManageJobs = React.lazy(() => import("../ManageJobs"));
const AsyncPostJob = React.lazy(() => import("../PostJob"));
const NotFound = React.lazy(() => import("../NotFound"));
const AsyncCopyJob = React.lazy(() => import("../CopyJob"));
const AsyncCaseClose = React.lazy(() => import("../CaseClose"));

const AsyncComingSoon = React.lazy(() =>
  import("@pga/pga-component-library").then((module) => ({
    default: module.ComingSoon,
  })),
);

const renderJobSearch = withPageMetadata(metadata("Job Board"))(AsyncJobSearch);
const renderJobDashboard = withPageMetadata(metadata("Job Dashboard"))(
  AsyncJobDashboard,
);

export const privateRoutes = [
  {
    path: "/manage-jobs",
    redirectTo: "/",
    component: withPageMetadata(metadata("Manage Job"))(AsyncManageJobs),
  },
  {
    path: "/post",
    redirectTo: "/",
    component: withPageMetadata(metadata("Post A Job"))(AsyncPostJob),
  },
  {
    path: "/copy/:id",
    redirectTo: "/",
    component: withPageMetadata(metadata("Copy a Job"))(AsyncCopyJob),
  },
  {
    path: "/new-hire-response/:id",
    redirectTo: "/",
    component: withPageMetadata(metadata("Case Close Response"))(
      AsyncCaseClose,
    ),
  },
  {
    path: "/recommended",
    redirectTo: "/",
    component: withPageMetadata(metadata("Recommended Jobs"))(
      RecommendedJobsPage,
    ),
  },
];

export default () => (
  <>
    <RouteChangeHandler />
    <Suspense fallback={<LoadingComponent />}>
      <Switch>
        <Route exact path="/" component={renderJobDashboard} />
        <Route exact path="/search" component={renderJobSearch} />
        <Route
          exact
          path="/login"
          component={(props) => {
            const page = path(["location", "state", "page"], props);
            return (
              <RedirectToLogin
                returnTo={
                  page
                    ? window.location.origin + page
                    : `${window.location.origin}/manage-jobs`
                }
              />
            );
          }}
        />
        <Route
          path="/board"
          component={withPageMetadata(metadata("Job Board"))(AsyncJobSearch)}
        />
        <Route
          path="/detail/:id"
          component={withPageMetadata(metadata("Job Details"))(
            AsyncJobDetailPage,
          )}
        />
        <Route
          path="/application/thank-you"
          component={AsyncApplicationSubmittedPage}
        />
        <Route exact path="/logout" component={AsyncLogout} />
        {privateRoutes.map((routeProps) => (
          <AuthRedirect key={routeProps.path} {...routeProps} />
        ))}
        <PrivateRoute
          path="/edit/:id"
          component={withPageMetadata(metadata("Edit Job"))(AsyncEditJob)}
        />
        <Route exact path="/coming-soon" component={AsyncComingSoon} />
        <Route component={withPageMetadata(metadata("NOT FOUND"))(NotFound)} />
      </Switch>
    </Suspense>
  </>
);
